import pricingEstimateHasPrice from "../hasPrice";

type PricingEstimateGetPriceParam0Type = {
  pricingEstimate: ReturnType<
    typeof import("@cloudspire/legacy-resources/src/normalizers/pricing/estimate").pricingEstimateParseData
  >;
};

const pricingEstimateGetPrice = ({
  pricingEstimate,
}: PricingEstimateGetPriceParam0Type) => {
  if (!pricingEstimateHasPrice({ pricingEstimate })) {
    return null;
  }

  return pricingEstimate.amount;
};

export default pricingEstimateGetPrice;
